//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import {getDateDiff} from 'common/js/util'
import uniLoadMore from "@/components/uni-load-more/uni-load-more.vue"
const audio = uni.createInnerAudioContext()
export default {
	data(){
		return {
			list:[],
			isFixed:false,
			end:false,
			count:0,
			voiceType: {
				static: require('static/sound/voice.png'),
				dynamic: require('static/sound/sound.gif')
			},
			detail:{
				images:[]
			},
			commentText:'',
			commentItem:{
				
			},
			status:0,
			userLikesCounts:0,
			page: {
				pageSize: 10,
				currentPage: 1,
				count: 0,
				loading: false
			}
		}
	},
	components:{
		uniLoadMore
	},
	onLoad(event) {
		this.id=event.id
		this.getDetail()
		this.getUserLike()
	},
	methods:{
		getDetail () {
			let _this=this
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/share/queryById',
				data: {
					id:this.id
				},
				success:function(result){
					
				}
			}).then(result=>{
				result.data.voice='static'
				_this.detail = result.data
				_this.detail.createTime = getDateDiff(_this.detail.createTime)
				_this.detail.nickName = decodeURI(_this.detail.nickName)
				_this.detail.content = decodeURI(_this.detail.content)
				_this.detail.images = _this.detail.images ? _this.detail.images.split(',') : []
				_this.page.loading=false
				_this.getContation()
				_this.comment(this.detail, true)
		  	})
		},
		getUserLike(){
			let _this=this
			this.$ajax({
				method: 'post',
				url: '/weChat/userlikes/selectStatus',
				data: {
					contentId: this.id,
					userId: this.$store.state.userInfo.memberId
				}
			}).then(result=>{
				if(result.data){
					_this.status = result.data.status
					_this.userLikesCounts = result.data.userLikesCounts
				}
				
			})
		},
		getContation(){
			let _this=this
			this.$ajax({
				method: 'post',
				url: '/weChat/cms/reviewmanagement/queryByContation',
				data: {
					messageId: this.id,
					currentPage: 1,
					pageSize: 999,
					userId: this.$store.state.userInfo.memberId
				}
			}).then(result=>{
				_this.detail.commentResults = _this.$set(_this.detail, 'commentResults', result.data.map(t => {
					return {
					  ...t,
					  createTime: getDateDiff(t.createTime),
					  nickname: decodeURI(t.nickName),
					  replynickName: decodeURI(t.replynickName),
					  replyContent: _this.escape2Html(decodeURI(t.replyContent))
					}
				}))
			})			
		},
		giveLike(){
			let _this=this
			this.$ajax({
				method: 'post',
				url: this.status === 2?'/weChat/userlikes/add':'/weChat/userlikes/updateStatus',
				data: {
					userId: this.$store.state.userInfo.memberId,
					contentId: this.id,
					appId: '111',
					status: this.status === 0 ? 1 : 0
				}
			}).then(result=>{
				_this.status === 1?(_this.userLikesCounts-=1,_this.status=0):(_this.userLikesCounts+=1,_this.status=1)
			})
		},
		playSounds(){
			audio.src=this.$getImg(this.detail.mediaUrl)
			if(this.detail.voice=='static'){
				this.detail.voice='dynamic'					
				audio.play()
			}
			else{
				this.detail.voice='static'
				audio.pause()
			}
		},
		escape2Html (str) {
		  let arrEntities = {'lt': '<', 'gt': '>', 'nbsp': ' ', 'amp': '&', 'quot': '"'}
		  return str.replace(/&(lt|gt|nbsp|amp|quot);/ig, function (all, t) { return arrEntities[t] })
		},
		linkToDetail(id){
			uni.navigateTo({
				url:'/pages/soundWall/detail?id='+id
			})
		},
		textInput(event){
			this.commentText=event.detail.value
		},
		preview(e,i){
			let list=e.map(res=>{
				return this.$getImg(res)
			})
			uni.previewImage({
				urls:list,
				current:i
			})
		},
		submit(){
			this.loading = true
			let _this=this
			if(this.commentText){
				this.$ajax({
					method: 'post',
					url: '/weChat/cms/reviewmanagement/add',
					data: {
						replyContent: this.commentText,
						userId: this.$store.state.userInfo.memberId,
						messageId: this.detail.id,
						replyId: this.commentItem.isOrigin ? '' : this.commentItem.id,
						messageType: 'share'
					}
				}).then(result=>{
					_this.loading=false
					_this.commentText=''
					_this.getContation()
					uni.showToast({
						title:'评论成功！',
						icon:'none'
					})
				})
			} else {
				uni.showToast({
					title:'评论不能为空！',
					icon:'none'
				})
			}
		},
		comment (item, isOrigin) {
			this.commentItem = JSON.parse(JSON.stringify(item || this.detail))
			this.commentItem.replynickName = this.commentItem.replynickName ? this.commentItem.replynickName : this.commentItem.nickname
			this.commentItem.isOrigin = isOrigin
			this.showCommentInput = true
		}
	}
}
